export const alertMessage = {
    alertSinglePublish: 'This module has a different number of SKUs with respect to the previous month. Please, proceed only if you are sure.',
    alertMassivePublish: 'One or more modules have a different number of SKUs with respect to the previous month. Please, proceed only if you are sure.'
}